import { render } from "./Chat.vue?vue&type=template&id=1274b934"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Chat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1274b934"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1274b934', __exports__)) {
    api.reload('1274b934', __exports__)
  }
  
  module.hot.accept("./Chat.vue?vue&type=template&id=1274b934", () => {
    api.rerender('1274b934', render)
  })

}


export default __exports__